import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrganizationDashboardComponent } from './pages/dashboard/dashboard.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ProcedureComponent } from './pages/procedure/procedure.component';
import { CalendarComponent } from './pages/schedule/calendar/calendar.component';
import { OrganizationPractitionerComponent } from './pages/practioner/practioner.component';
import { FirstAccessGuard } from 'app/core/guards/first-access.guard';
import { OrganizationUsersComponent } from './pages/users/users.component';
import { PermissionGuard } from 'app/core/guards/permissions.guard';
import { OrganizationScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { UserTypeGuard } from 'app/core/guards/user-type.guard';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { OrganizationBankAccountComponent } from './components/organization-bank-account/organization-bank-account.component';
import { OrganizationPatientsComponent } from './pages/patients/patients.component';

const routes: Routes = [
  {
    path: '',
    component: OrganizationScheduleStatusComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'meus-dados',
    component: ProfileComponent,
    canActivate: [AuthGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'especialistas',
    component: OrganizationPractitionerComponent,
    canActivate: [FirstAccessGuard, AuthGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'calendario',
    component: CalendarComponent,
    canActivate: [FirstAccessGuard, AuthGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'exames',
    component: ProcedureComponent,
    canActivate: [FirstAccessGuard, AuthGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'usuarios',
    component: OrganizationUsersComponent,
    canActivate: [FirstAccessGuard, AuthGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'pacientes',
    component: OrganizationPatientsComponent,
    canActivate: [FirstAccessGuard, AuthGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'faturamento',
    component: OrganizationDashboardComponent,
    canActivate: [FirstAccessGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'dados-bancarios',
    component: OrganizationBankAccountComponent,
    canActivate: [FirstAccessGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
  {
    path: 'agendados',
    component: OrganizationScheduleStatusComponent,
    canActivate: [FirstAccessGuard, PermissionGuard, UserTypeGuard],
    data: {
      onlyUserType: 'organization',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganizationRoutingModule {}
